module.exports = __webpack_public_path__ + "static/media/steamcouture-5.f887be84.jpg";